import MonitoringService from '../services/monitoring.service'

const initialState = {
	extraCost: null,
};

const state = () => ({...initialState});

const getters = {

};

const actions = {
	async getExtraCostForDeps({commit}, depId) {
		try {
			const response = await MonitoringService.getExtraCostByDeps(depId);
			commit('setExtraCost', response);
		} catch (e) {
			return 0;
		}
	}
};

const mutations = {
	setExtraCost(state, response) {
		state.extraCost = response.data;
	}
};

export const monitoring = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

